<template>
  <v-card class="mx-7" flat>
    <v-card-title>
      {{ questionnaire.description }}
      <v-spacer></v-spacer>
      <v-btn depressed color="primary" @click="download(questionnaireDoc)">
        download
      </v-btn>
    </v-card-title>

    <v-card-text class="questionnaire-form">
      <div v-if="questionnaire.metadata != ''">
        <div class="mb-3" v-if="!showAll">
          {{
            questionnaire.metadata
              ? questionnaire.metadata.substring(0, 300) + " ..."
              : ""
          }}

          <span
            class="blue--text text-caption"
            style="cursor: pointer"
            @click="readMore(true)"
          >
            Read more
          </span>
        </div>
        <div class="mb-3" v-if="showAll">
          {{ questionnaire.metadata ? questionnaire.metadata : "" }}

          <span
            class="blue--text text-caption"
            style="cursor: pointer"
            @click="readMore(false)"
          >
            Read less
          </span>
        </div>
        <v-divider></v-divider>
      </div>

      <v-form v-model="isValid" ref="qForm">
        <!-- section -->
        <div v-for="(s, code) in sections" :key="code">
          <v-card-title> {{ s.code }}: &thinsp; {{ s.metadata }} </v-card-title>

          <!-- parts -->
          <div v-for="p in parts(s.code)" :key="p.code">
            <v-card-subtitle class="text-h5">
              {{ p.metadata }}
            </v-card-subtitle>

            <!-- questions -->
            <v-card-text v-for="q in questions(s.code, p.code)" :key="q.code">
              <div class="d-flex">
                <span class="text-h6"> {{ q.code }}.</span>
                &ensp;
                <span class="text-h6"> {{ q.question }}</span>
                &thinsp;
                <span class="error--text text-h5" v-if="!q.Optional">*</span>

                <v-spacer></v-spacer>
                <div v-if="q.maxSelections >= 1" class="ma-auto">
                  {{ q.minSelections }}
                  {{
                    q.maxSelections !== q.minSelections
                      ? `&thinsp;-&thinsp;${q.maxSelections}`
                      : ""
                  }}
                  selection(s)
                </div>
              </div>

              <!-- choices -->
              <v-card-text v-if="q.type === 'Options'">
                <div v-if="q.maxSelections > 1">
                  <v-checkbox
                    v-for="(o, i) in q.questionChoices"
                    :key="i"
                    :value="o"
                    :label="o.description"
                    multiple
                    @change="insertChoice($event, 'multiple', q, o.code)"
                  />
                </div>
                <div v-else>
                  <v-radio-group column class="ml-2">
                    <v-radio
                      v-for="(o, i) in q.questionChoices"
                      :key="i"
                      :value="o"
                      :label="o.description"
                      @change="insertChoice(o, 'single', q, o.code)"
                      dense
                    ></v-radio>
                  </v-radio-group>
                </div>
              </v-card-text>

              <v-card-text v-if="q.type === 'Text'">
                <v-textarea
                  @input="insertAnswer($event, q)"
                  outlined
                  rows="2"
                  auto-grow
                  :rules="!q.Optional ? rules.required : []"
                  maxlength="250"
                  hint="250 characters max"
                  persistent-placeholder
                  placeholder="Type your feedback here..."
                  dense
                ></v-textarea>
              </v-card-text>
            </v-card-text>
          </div>
          <v-divider></v-divider>
        </div>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-btn block color="primary" @click="submit()">
        Submit Feedback
        <v-icon class="mx-2">chat</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import FileMixin from "../mixins/FileMixin";
import helpers from "../helpers/helper";
import RouterMixin from "../mixins/RouterMixin.js";

export default {
  name: "FeedbackCard",
  mixins: [FileMixin, RouterMixin],
  data: function () {
    return {
      isValid: false,
      showAll: false,
      formData: [],
    };
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Feedback/getQuestion", v.decodeRoute(to.params.code));
      v.$store.dispatch("Feedback/getQuestionnaireDocument", {
        docNo: v.decodeRoute(to.params.code),
      });
    });
  },
  mounted() {
    Event.$on("fetchDocument", () => {
      this.$router.replace({
        name: "FeedbackDocument",
        params: {
          docNo: this.$route.params.docNo,
          code: this.$route.params.code,
          reference: this.$route.params.reference,
        },
      });
    });
  },
  computed: {
    questionnaire() {
      return this.$store.getters["Feedback/feedbackGetters"]("question");
    },
    questionnaireDoc() {
      return this.$store.getters["Feedback/feedbackGetters"](
        "questionnaireDocument"
      );
    },
    sections() {
      return this.questionnaire.questionnaireSections;
    },
    getImage() {
      return require("../assets/feedback-svg.png");
    },
    rules() {
      return {
        required: [(v) => !!v || "field is required"],
      };
    },
    maxQuestions() {
      return this.questionnaire.questionnaireQuestions.filter(
        (item) => !item.Optional
      ).length;
    },
  },
  methods: {
    readMore(value) {
      this.showAll = value;
    },
    parts(section) {
      return this.questionnaire.questionnaireParts.filter(
        (item) => item.section === section
      );
    },
    questions(section, part) {
      return this.questionnaire.questionnaireQuestions.filter(
        (item) => item.section === section && item.part == part
      );
    },
    insertAnswer(event, q) {
      q.referenceHeader = this.decodeRoute(this.$route.params.docNo);
      q.reference = this.decodeRoute(this.$route.params.reference);
      if (
        this.formData.find(
          (item) =>
            item.code === q.code &&
            item.section === q.section &&
            item.part == q.part
        )
      ) {
        q.answer = event;
      } else {
        q.answer = event;
        this.formData.push(q);
      }
    },
    insertChoice(event, type, q, code) {
      const question = this.formData.find(
        (item) =>
          item.code === q.code &&
          item.section === q.section &&
          item.part === q.part
      );
      if (question !== undefined) {
        console.log("question exists");
        if (type === "multiple") {
          event.map((item) => {
            item.referenceHeader = this.decodeRoute(this.$route.params.docNo);
            item.reference = this.decodeRoute(this.$route.params.reference);
            item.choice = item.code;
          });
          const index = question.answerChoices.findIndex(
            (item) => code === item.code
          );
          if (index !== -1) {
            question.answerChoices.splice(index, 1);
          } else {
            question.answerChoices.push(event[0]);
          }
        } else {
          event.referenceHeader = this.decodeRoute(this.$route.params.docNo);
          event.reference = this.decodeRoute(this.$route.params.reference);
          event.choice = event.code;
          question.answerChoices = [event];
        }
      } else {
        q.answerChoices = !Array.isArray(event) ? [event] : event;
        q.answerChoices.map((item) => {
          item.referenceHeader = this.decodeRoute(this.$route.params.docNo);
          item.reference = this.decodeRoute(this.$route.params.reference);
          item.choice = item.code;
        });
        q.referenceHeader = this.decodeRoute(this.$route.params.docNo);
        q.reference = this.decodeRoute(this.$route.params.reference);
        console.log("doesnt exist");
        this.formData.push(q);
      }
    },
    submit: function () {
      if (!this.isValid) {
        this.$refs.qForm.validate();
      } else {
        this.formData.map((item) => {
          item.reference = this.decodeRoute(this.$route.params.reference);
          item.question = item.code;
          item.referenceHeader = this.decodeRoute(this.$route.params.docNo);
        });
        const item = this.formData.find((item) => {
          item.type === "Options" &&
            (item.minSelections > item.answerChoices.length ||
              item.answerChoices.length > item.maxSelections);
        });
        if (item) {
          return Event.$emit(
            "ApiWarning",
            `Question ${item.question} requires ${item.maxSelections} maximum selections and ${item.minSelections} minimum selections`
          );
        } else if (
          this.formData.filter((item) => !item.Optional).length !==
          this.maxQuestions
        ) {
          return Event.$emit(
            "ApiWarning",
            `Kindly fill in all the required questions`
          );
        } else if (!item) {
          this.$store.dispatch("Feedback/giveFeedback", this.formData);
        }
      }
    },
    download(item) {
      var a = document.createElement("a");
      this.mime = helpers.detectMimeType(item);
      this.ext = helpers.fileExtension(item);
      a.href = `data:${this.mime};base64,${item}`;
      a.download = `Attachment.${this.ext}`;
      a.click();
    },
  },
};
</script>
<style scoped>
@import url("../styles.css");
</style>
